module.exports = __webpack_public_path__ + "static/media/qzB2zKk.da3563e0.jpg";